import React, { useEffect, useState } from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";
import { PageHeader, Loading, Card } from "../components/common";

export default function KPI() {
  const { t } = useI18n();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/kpi").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loading />;

  const groups = { KPI: rows.filter((r) => r.type === "KPI"), KRI: rows.filter((r) => r.type === "KRI"), KCI: rows.filter((r) => r.type === "KCI") };
  const meta = { KPI: { label: "Key Performance Indicators", color: "text-emerald-600" }, KRI: { label: "Key Risk Indicators", color: "text-red-600" }, KCI: { label: "Key Control Indicators", color: "text-blue-600" } };
  const Trend = ({ t }) => t === "up" ? <TrendingUp className="h-4 w-4 text-emerald-500" /> : t === "down" ? <TrendingDown className="h-4 w-4 text-red-500" /> : <Minus className="h-4 w-4 text-slate-400" />;

  return (
    <div>
      <PageHeader title={t("nav.kpi")} subtitle="AI performance, risk and control indicators" summary="KPI, KRI and KCI dashboards tracking AI performance, risk and control effectiveness against targets." />
      {Object.entries(groups).map(([g, items]) => (
        <div key={g} className="mb-8">
          <h3 className={`mb-3 text-sm font-bold uppercase tracking-wider ${meta[g].color}`}>{g} — {meta[g].label}</h3>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
            {items.map((k) => (
              <div key={k.id} data-testid={`kpi-${k.id}`} className="rounded-2xl border border-slate-200 bg-white p-4 card-shadow">
                <div className="flex items-start justify-between"><p className="text-xs font-medium text-slate-500">{k.name}</p><Trend t={k.trend} /></div>
                <p className="mt-2 text-2xl font-bold font-head text-slate-900">{k.value}</p>
                <p className="mt-1 text-xs text-slate-400">Target: {k.target}</p>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
